import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

function Type5Scoreboard(props) {
    const localClasses = useStyles(props.config.theme);
    return (
        <div className={localClasses.videoDiv}>
           <video width="100%" autoPlay muted playsinline poster="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Solid_green.svg/1024px-Solid_green.svg.png" style={{ backgroundColor: 'green' }}>
              <source src={props.config.videoUrl} type="video/mp4"/>
           </video>
        </div>
    )
}

export default Type5Scoreboard;

const useStyles = makeStyles((theme) => ({
    videoDiv: {
        position: "fixed",
        left: 0, //'30px',
        top: 0, //'30px',
        width: ( props ) => props.width,
        height: ( props ) => props.height,
    }
}));
